import ajaxService from './ajaxService';

export default {
  // 取得 商店
  getstore(param) {
    try {
      const queryString = new URLSearchParams(param).toString();
      return ajaxService.post(`/sct/get/api/v1/store?${queryString}`);
    } catch (err) {
      return err.response;
    }
  },
};
